export default __webpack_public_path__ + "static/media/activeTarget.7c430a65.svg";